import React, {useEffect, useState} from "react";
import {getClients, getCMSAssets, getCMSGeneral} from "../../../utils/cms.utils";
import SafeImage from "../../../layout/reusable/SafeImage";

const BannerOne = () => {
    const [clients, setClients] = useState([]);
    const [general, setGeneral] = useState(null);
    const [assets, setAssets] = useState(null);

    useEffect(() => {
        setClients(getClients());
        setGeneral(getCMSGeneral());
        setAssets(getCMSAssets());
    }, []);

    if (!general || !assets) return null;

    return (
        <>
            {/* ================= Banner One ================= */}
            <div
                className="banner__one"
                style={{backgroundImage: `url(${assets.main_banner})`}} // ⬅️ TETAP
            >
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="banner__one-content">
                                <h1 className="wow fadeInRight" data-wow-delay=".2s">
                                    Construction
                                </h1>

                                <h2 className="wow fadeInRight" data-wow-delay=".3s">
                                    With <span>Dedication</span> & <span>Devotion</span>
                                </h2>

                                <p className="wow fadeInRight" data-wow-delay=".4s">
                                    “Membangun dengan Dedikasi dan Sepenuh Hati”
                                </p>

                                <div
                                    className="banner__one-content-user wow fadeInUp"
                                    data-wow-delay=".6s"
                                >
                                    <img
                                        src={general.logo3}
                                        alt={general.companyName}
                                    />
                                    <div>
                                        <div>{general.companyName}</div>
                                        <div>Construction & Engineering Services</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ⬇️ IMAGE DIPISAH, SEPERTI DESAIN ASLI */}
                <div className="banner__one-image">
                    <SafeImage
                        src={assets.home_banner}
                        alt="Banner"
                        isCoverImage
                    />
                </div>
            </div>

            {/* ================= Clients ================= */}
            {clients.length > 0 && (
                <div className="banner__three">
                    {/* ===== SECTION TITLE ===== */}
                    <div className="banner__three-header text-center">
                        <p className="subtitle">OUR CLIENTS</p>
                        <h4 className="title">Trusted by Industry Leaders</h4>
                    </div>
                    <div className="scroll__slider">
                        <div className="text-slide">
                            <div className="sliders text_scroll">
                                <ul>
                                    {clients.map((logo, i) => (
                                        <li key={i}>
                                            <img src={logo} alt="client" className="logo-client"/>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="sliders text_scroll">
                                <ul>
                                    {clients.map((logo, i) => (
                                        <li key={`dup-${i}`}>
                                            <img src={logo} alt="client" className="logo-client"/>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};


export default BannerOne;
